export const FETCH_PAGES = 'FETCH_PAGES';
export const DELETE_PAGES = 'DELETE_PAGES';